"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _regeneratorValues2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regeneratorValues.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _cookie = require("@/utils/cookie");
var _badge = require("@/api/badge");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { writeGaEvent } from '@/utils/ga'
// import { showDebugLog, displayPopupMessage } from '@/utils/log'
var _default2 = exports.default = {
  props: {
    badges: {
      type: Array,
      default: function _default() {
        return {
          badges: []
        };
      }
    }
  },
  data: function data() {
    return {
      myBadges: [],
      tableLoading: false
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var token, badgesAll, _loop, i;
      return (0, _regenerator2.default)().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            token = (0, _cookie.getCookie)('ACCESS_TOKEN');
            _this.tableLoading = true;
            _context2.n = 1;
            return (0, _badge.getBadgeList)(token, {
              page: 1,
              limit: 100,
              sorting: 'title'
            });
          case 1:
            badgesAll = _context2.v;
            _loop = /*#__PURE__*/(0, _regenerator2.default)().m(function _loop(i) {
              var badge;
              return (0, _regenerator2.default)().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    badge = badgesAll.data.rows.find(function (element) {
                      return element.id.toString() === _this.badges[i];
                    });
                    if (badge) {
                      _this.myBadges.push(badge);
                    }
                  case 1:
                    return _context.a(2);
                }
              }, _loop);
            });
            i = 0;
          case 2:
            if (!(i < _this.badges.length)) {
              _context2.n = 4;
              break;
            }
            return _context2.d((0, _regeneratorValues2.default)(_loop(i)), 3);
          case 3:
            i++;
            _context2.n = 2;
            break;
          case 4:
            _this.tableLoading = false;
          case 5:
            return _context2.a(2);
        }
      }, _callee);
    }))();
  }
};